import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { BackgroundJobKindDto } from "@/api/dtos";
import type { BackgroundJobFieldType, BackgroundJobKind } from "./_models/BackgroundJob";
import { toBackgroundJobFetchError } from "./backgroundJob.utils";
import { BackgroundJobTags } from "./BackgroundJobTags";

/** Every kind of background job (GET /background-job-kinds): its label, whether a schedule can run it, and its input fields. */
export const getBackgroundJobKindListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBackgroundJobKindList: builder.query<BackgroundJobKind[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<BackgroundJobKindDto[]>(
            `${backendBase()}/background-job-kinds`,
            { headers: { Accept: "application/json" } },
          );
          const kinds: BackgroundJobKind[] = res.data.map((x) => {
            const fields = (x.fields ?? []).map((field) => {
              return {
                name: field.name,
                label: field.label,
                type: field.type as BackgroundJobFieldType,
                required: field.required,
                options: field.options ?? [],
                help: field.help,
              };
            });
            return { kind: x.kind, label: x.label, schedulable: x.schedulable, fields };
          });
          return { data: kinds };
        }
        catch (e) {
          return { error: toBackgroundJobFetchError(e) };
        }
      },
      providesTags: [{ type: BackgroundJobTags.BackgroundJobKind, id: "LIST" }],
    }),
  }),
});

export const getBackgroundJobKindList = getBackgroundJobKindListApi.endpoints.getBackgroundJobKindList;
